import instance from "../http";
import { getHeader } from "../../utils/utils";
import { personas } from "../../constants/path";

export async function getPersonaApi(perPage = 10, page = 1, search = "", personaUUID) {
  const headers = getHeader();
  if(personaUUID !== undefined){
    const response = await instance.get(
      `${personas.GET_BASE_PROMPT}?page=${page}&perPage=${perPage}&search=${search}&selectedPersonaUUID=${personaUUID}`,
      headers
    );
    return response;
  }else{
    const response = await instance.get(
      `${personas.GET_BASE_PROMPT}?page=${page}&perPage=${perPage}&search=${search}`,
      headers
    );
    return response;
  }
 
}

export async function createPersonaApi(promptData) {
  const headers = getHeader();
  headers.headers["Content-Type"] = "multipart/form-data";
  const response = await instance.post(
    personas.CREATE_BASE_PROMPT,
    promptData,
    headers
  );
  return response;
}

export async function showPersonaApi(uuid) {
  const headers = getHeader();
  const response = await instance.get(
    personas.SHOW_BASE_PROMPT.replace(":uuid", uuid),
    headers
  );
  return response;
}

export async function updatePersonaApi(uuid, promptData) {
  const headers = getHeader();
  headers.headers["Content-Type"] = "multipart/form-data";
  const response = await instance.patch(
    personas.UPDATE_BASE_PROMPT.replace(":uuid", uuid),
    promptData,
    headers
  );
  return response;
}

export async function deletePersonaApi(uuid) {
  const headers = getHeader();
  const response = await instance.delete(
    personas.DELETE_BASE_PROMPT.replace(":uuid", uuid),
    headers
  );
  return response;
}

export async function bulkDeletePersonaApi(uuids) {
  const headers = getHeader();
  const response = await instance.post(
    personas.BULK_DELETE_BASE_PROMPT,
    { persona_uuids: uuids },
    headers
  );
  return response;
}

export async function activatePersonaApi(uuid) {
  const headers = getHeader();
  const response = await instance.patch(
    personas.ACTIVATE_BASE_PROMPT.replace(":uuid", uuid),
    {},
    headers
  );
  return response;
}

